import React, { CSSProperties, useContext, createContext, ReactNode, useEffect, useState, useMemo, useRef } from 'react';
import RootStore from '../../store/RootStore';
import { inject, observer } from 'mobx-react';
import intl from 'react-intl-universal';
import { getPageSameType, isIphoneX, getHomeTabName, uuid, debounce, getHomeTabStatus, navigatorTo, toOrderPage } from '../../utils/util';
import { IComponentNavigator, IComponentContainer, IComponent } from '../../component.d';
import AllForBottom, { INavigatorTab } from './AllForBottom';
import AllForRedPackComponents from '../RedPack/AllRedPackComponents';
import useResize from '../hooks/useResize';
import useScroll from '../hooks/useScroll';
import './AllForNavigator.scss';
import { pushHistory } from '../../utils/history';
import { PageContext } from './PageContext';
import stat from '../../utils/stat';
import asyncComponent from '../AsyncComponent';

const HomePage = asyncComponent(() => import('./HomePage'));
const MePage = asyncComponent(() => import('../../pages/Me'));
const FolloweePage = asyncComponent(() => import('../Followee/AllForFollowee'));

let __lastScrollTop = 0;

export interface IAllForNavigator {
  rootStore?: RootStore;
}

const MemoPage = (props: {
  active?: boolean;
  isMain: boolean;
  children?: any;
  pageHeight?: number;
  rootStore?: RootStore;
}) => {
  const { active, isMain, pageHeight } = props;
  const [component, setComponent] = useState(null as any);

  useEffect(() => {
    if (!component && active) {
      setComponent(props.children);
    }
  }, [component, active]);

  const [cid, setCid] = useState('');

  useEffect(() => {
    setCid(`memo_${uuid()}`);
  }, []);

  useEffect(() => {
    const onScrollBottom = (e: any) => {
      // console.log(`到底了`);
      window.dispatchEvent(new Event(`page-scroll-bottom-${cid}`));
    };

    if (cid && active) {
      window.addEventListener('window-scroll-bottom', onScrollBottom);
    }

    return () => {
      window.removeEventListener('window-scroll-bottom', onScrollBottom);
    }
  }, [cid, active]);

  useEffect(() => {
    const onScroll = (e: any) => {
      window.dispatchEvent(new Event(`page-scroll-move-${cid}`));
    };

    if (cid && active) {
      window.addEventListener('window-scroll-move', onScroll);
    }

    return () => {
      window.removeEventListener('window-scroll-move', onScroll);
    }
  }, [cid, active]);

  useEffect(() => {
    if (isMain && active) {
      // 如果当前是主页，那么在显示的时候，要滚动到指定位置
      let dom = window.document.querySelector('.decorate-container');
      dom && dom.scrollTo({
        top: __lastScrollTop
      });
    }
  }, [isMain, active]);

  const wrapper = useRef<HTMLDivElement>(null)
  const [height, setHeight] = useState(0);

  useEffect(() => {
    if (wrapper && wrapper.current) {
      let parentNode = window.document.querySelector('.decorate-container') as HTMLDivElement;
      if (parentNode) {
        setHeight(parentNode.offsetHeight);
      }
    }
  }, [wrapper, pageHeight]);

  useEffect(() => {
    // 如果当前是主页的话，需要恢复一下浏览位置
  }, []);

  return <div className="memo-page" style={{ display: active ? 'block' : 'none' }} ref={wrapper}>
    <PageContext.Provider value={{ cid: cid }}>
      {component ? component : null}
    </PageContext.Provider>
    <div id={`page-top-${cid}`} className="page-top"></div>
    <div id={`page-bottom-${cid}`} className="page-bottom" style={{ top: height }}></div>
  </div>;
};

const getHomeTabOption = () => {
  let status = getHomeTabStatus();
  if (status == 'home') {
    return {
      type: 'home',
      icon: require('../../svg/v2/home.svg'),
      active: require('../../svg/v2/home.svg'),
      text: getHomeTabName()
    }
  } else {
    return {
      type: 'home',
      useBack: true,
      icon: require('../../svg/v2/home_back.svg'),
      active: require('../../svg/v2/home_back.svg'),
      text: getHomeTabName()
    }
  }
};

const Index = (props: IAllForNavigator) => {
  const { wxuserStore, pagedataStore } = props.rootStore!;
  const { pageDetail, configDetail } = window;
  const [currentTab, setCurrentTab] = useState('home');
  const [pageHeight, setPageHeight] = useResize({
    defaultValue: 0,
    onChange: (e?: any) => {
      return window.innerHeight;
    }
  });

  // console.log(`render main-page`, pageHeight);

  const [tabs, setTabs] = useState([] as INavigatorTab[]);
  const [renderNavigatorByLocal, setRenderNavigatorByLocal] = useState(false);
  const [navigator, setNavigator] = useState(null as any);

  useEffect(() => {
    const navigator = getPageSameType(pageDetail.template, [], ['navigator']);
    const hasNavigator = navigator && navigator.length;

    const hasOrder = navigator && navigator.length ? !!navigator.find((it: any) => it && it.order) : false;
    const hasMy = navigator && navigator.length ? (!!navigator.find((it: any) => it && it.my) && Number(window.configDetail.active_on)) : false;
    const hasFind = navigator && navigator.length ? (!!navigator.find((it: any) => it && it.find !== false) && Number(window.configDetail.active_on)) : false;
    const useLocalDom = navigator && navigator.length ? !!navigator.find((it: any) => it && it.useLocalDom === true) : false;

    setRenderNavigatorByLocal(useLocalDom);
    setNavigator(navigator && navigator.length ? navigator[0] : null);

    let finalTabs = [] as INavigatorTab[];
    // 默认肯定是有首页的
    finalTabs.push(getHomeTabOption());

    // if(!!+configDetail.use_face && Number(configDetail.active_on) && hasNavigator) {
    if (hasFind) {
      finalTabs.push({
        type: 'people',
        icon: require('../../svg/v2/people.svg'),
        active: require('../../svg/v2/people_active.svg'),
        text: intl.get('FindPhoto')
      });
    }
    if (hasOrder) {
      finalTabs.push({
        type: 'order',
        icon: require('../../svg/v2/preorder.svg'),
        active: require('../../svg/v2/preorder.svg'),
        text: intl.get('Preorder')
      });
    }
    if (hasMy) {
      finalTabs.push({
        type: 'me',
        icon: require('../../svg/v2/me.svg'),
        active: require('../../svg/v2/me_active.svg'),
        text: intl.get('My')
      });
    }

    if (finalTabs && finalTabs.length > 0) {
      setTabs(finalTabs);
    }
  }, [currentTab, pagedataStore.renderMode]);

  const onTabClick = (tab: INavigatorTab) => {
    if (currentTab == 'home') {
      // 如果是主页，则记录一下滚动位置
      __lastScrollTop = window.document.querySelector('.decorate-container')!.scrollTop;
    }
    if (tab && tab.type == 'order') {
      return toOrderPage('from_order_bottom');
    }
    else if (tab && tab.type == 'home' && currentTab == 'home' && tab.useBack) {
      navigatorTo({
        type: 'gallery',
        link_id: pagedataStore.parentLinkId
      });
    }
    else {
      if (['people', 'me'].indexOf(tab.type) > -1) {
        if (wxuserStore.user.is_mock) {
          wxuserStore.auth();
          return false;
        }
      }
      if (tab.type != currentTab) {
        pushHistory(tab.type, () => {
          setCurrentTab(currentTab);
        });
      }
      setCurrentTab(tab.type);
    }

    if (tab && tab.type) {
      const statType = ({
        'order': 'BottomTab_3',
        'home': 'BottomTab_0',
        'people': 'BottomTab_1',
        'me': 'BottomTab_4',
      })[tab.type];
      statType && stat.event(statType);
    }
  };

  const renderPage = () => {
    const getPageByType = (type: string) => {
      if (type == 'home') {
        return <HomePage />;
      }
      if (type == 'order') {
        return <div />;
      }
      if (type == 'people') {
        return <FolloweePage />;
      }
      if (type == 'me') {
        return <MePage />
      }
    };
    return tabs.map((it: INavigatorTab) => {
      return <MemoPage key={it.type} active={it.type == currentTab} isMain={it.type == 'home'} pageHeight={pageHeight}>
        {getPageByType(it.type)}
      </MemoPage>
    });
  }

  const wrapper = useRef<HTMLDivElement>(null);
  const scroll = useScroll({
    bottomDistance: window.document.body.offsetHeight ? window.document.body.offsetHeight * 2 : 1500,
    wait: 16,
    onTouchBottom: debounce(() => {
      window.dispatchEvent(new Event('window-scroll-bottom'));
    }),
    onScroll: (e: any) => {
      window.dispatchEvent(new Event('window-scroll-move'));
    }
  });
  useEffect(() => {
    if (wrapper && wrapper.current) {
      scroll.setWrapper(wrapper);
    }
  }, [wrapper]);

  return <div
    className={`main-page ${pagedataStore.renderMode == 'pc' ? 'pc-render-mode' : ''}`}
    style={{ height: pageHeight }}
  >
    {renderNavigatorByLocal ? <AllForBottom component={navigator} tabs={tabs} currentTab={currentTab} onTabClick={onTabClick} /> : null}
    <div className="decorate-container" ref={wrapper}>
      {renderPage()}
    </div>
    {!renderNavigatorByLocal ? <AllForBottom component={navigator} tabs={tabs} currentTab={currentTab} onTabClick={onTabClick} /> : null}
    {Number(configDetail.use_package) ? <AllForRedPackComponents /> : null}
  </div>;
};

export default inject('rootStore')(observer(Index));
